import React from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
    const navigate = useNavigate();

    const quickActions = [
        {
            label: "تقرير سبر الأسعار اليومي",
            icon: "bi-table",
            path: "/admin/price-survey-matrix-report",
            color: "#1565c0",
            description: "عرض أسعار المواد في يوم محدد على مستوى المحافظات أو المدن أو القطاعات"
        },
        {
            label: "توليد QR",
            icon: "bi-qr-code-scan",
            path: "/admin/generate-uid",
            color: "#0dcaf0",
            description: "إنشاء رموز الاستجابة السريعة الذكية للفعاليات"
        },
        {
            label: "عرض الفعاليات",
            icon: "bi-building-check",
            path: "/admin/establishments",
            color: "#198754",
            description: "إدارة ومتابعة كافة المنشآت والفعاليات"
        },
        {
            label: "عرض الشكاوي",
            icon: "bi-chat-right-dots",
            path: "/admin/all-complaint",
            color: "#dc3545",
            description: "نظام معالجة وتدقيق شكاوي المواطنين"
        },
        {
            label: "أنواع الضبوط",
            icon: "bi-shield-exclamation",
            path: "/admin/violation-types-management",
            color: "#6f42c1",
            description: "الدليل الموحد لأنواع المخالفات والضبوط"
        },
        {
            label: "إدارة الدوريات",
            icon: "bi-exclamation-octagon",
            path: "/admin/patrol-rosters",
            color: "#c14242ff",
            description: "إنشاء دورية جديدة وتحديد الموظفين"
        },
        // {
        //     label: "اسناد مهمة",
        //     icon: "bi-exclamation-octagon",
        //     path: "/admin/inspection-mission/create",
        //     color: "#42c157ff",
        //     description: "إسناد مهمة لدورية معينة"
        // },
    ];

    return (
        // تم استخدام d-flex و flex-column لضمان احتواء العناصر بشكل عمودي سليم
        <div className="container-fluid d-flex flex-column align-items-center py-3 py-md-5"
            style={{
                direction: "rtl",
                minHeight: "100vh",
                background: "linear-gradient(180deg, #ffffff 0%, #f1f4f8 100%)",
                overflowX: "hidden"
            }}>

            {/* قسم الهوية البصرية - باستخدام فئات Bootstrap للنصوص */}
            <div className="text-center mb-4 mb-lg-5 animate-fade-in w-100">
                <div className="mb-3">
                    <img
                        src="/website-icon.png"
                        alt="شعار"
                        className="img-fluid"
                        style={{
                            maxHeight: "140px",
                            width: "auto",
                            filter: "drop-shadow(0 8px 12px rgba(0,0,0,0.1))"
                        }}
                    />
                </div>
                <h1 className="h3 fw-bold text-dark mb-1">الجمهورية العربية السورية</h1>
                <p className="lead text-muted small mb-4">المنظومة الإلكترونية لحماية المستهلك</p>

                {/* خطوط الألوان - تم تقليل العرض ليتناسب مع الشاشات الضيقة */}
                <div className="d-flex justify-content-center gap-1">
                    {/* <div className="bg-danger" style={{ width: "30px", height: "3px" }}></div> */}
                    {/* <div className="bg-light border" style={{ width: "30px", height: "3px" }}></div> */}
                    <div className="bg-success" style={{ width: "30px", height: "3px" }}></div>
                    <div className="bg-success" style={{ width: "30px", height: "3px" }}></div>
                    <div className="bg-success" style={{ width: "30px", height: "3px" }}></div>

                </div>
            </div>

            {/* لوحة التحكم السريعة - استغلال نظام الـ Grid بالكامل */}
            <div className="container">
                <div className="row g-3 g-lg-4 justify-content-center">
                    {quickActions.map((action, index) => (
                        /* توزيع الأعمدة: 
                           12: عمود واحد في الجوال
                           md-6: عمودين في الأجهزة المتوسطة (أو عند فتح القائمة الجانبية)
                           xl-3: أربعة أعمدة فقط في الشاشات العريضة جداً
                        */
                        <div key={index} className="col-12 col-md-6 col-xl-3">
                            <div
                                onClick={() => navigate(action.path)}
                                className="card h-100 border-0 shadow-sm p-3 p-lg-4 action-card"
                                style={{
                                    borderRadius: "1.5rem",
                                    cursor: "pointer",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease"
                                }}
                            >
                                {/* أيقونة الكرت */}
                                <div
                                    className="d-flex align-items-center justify-content-center mb-3"
                                    style={{
                                        width: "60px",
                                        height: "60px",
                                        backgroundColor: `${action.color}15`,
                                        color: action.color,
                                        borderRadius: "1rem",
                                        fontSize: "1.8rem"
                                    }}
                                >
                                    <i className={`bi ${action.icon}`}></i>
                                </div>

                                <h6 className="fw-bold text-dark mb-2">{action.label}</h6>
                                <p className="text-secondary small mb-3 flex-grow-1">
                                    {action.description}
                                </p>

                                <div className="text-start mt-auto">
                                    <span className="badge fw-light p-2"
                                        style={{
                                            backgroundColor: `${action.color}15`,
                                            color: action.color,
                                            fontSize: "0.75rem"
                                        }}>
                                        دخول <i className="bi bi-arrow-left ms-1"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* CSS Animation & Hover Effects */}
            <style>{`
                .action-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 1rem 3rem rgba(0,0,0,.1) !important;
                }
                .animate-fade-in {
                    animation: fadeIn 0.8s ease-out;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(15px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                /* لضمان عدم حدوث تداخل عند صغر عرض السايدبار */
                .container { max-width: 1200px; }
            `}</style>
        </div>
    );
};

export default Home;